<template>
    <div>
        <v-card ref="form">
                <v-card-title><v-icon>map</v-icon>&nbsp;<h3>{{ blagajna[0].Avt_blagajna }}</h3></v-card-title>
                        <v-divider></v-divider>
                <v-card-text>
                    <v-text-field
                    ref="name"
                    v-model="id_blagajne"
                    label="ID Blagajne"
                    placeholder="..."
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="naziv_blagajne"
                    label="Naziv blagajne"
                    placeholder="..."
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="zasedeno"
                    label="Zasedenih mest - parkomat"
                    placeholder="..."
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="P_mest"
                    label="Vseh parkirnih mest"
                    placeholder=""
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="zasedenost"
                    label="Zasedenost v %"
                    placeholder=""
                                disabled
                    ></v-text-field>
                    <!--<v-text-field
                    ref="name"
                    v-model="cas_osvezitve"
                    label="Čas osvežitve"
                    placeholder=""
                                disabled
                    ></v-text-field>-->
                    <v-text-field
                    ref="name"
                    v-model="realna_zasedenost"
                    label="Realno zasedenih mest"
                    placeholder=""
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="realna_zasedenost_procenti"
                    label="Realna zasedenost v %"
                    placeholder=""
                                disabled
                    ></v-text-field>
                    <v-text-field
                    ref="name"
                    v-model="sprememba_zasedenosti"
                    label="Vpiši trenutno število vozil na parkirišču"
                    placeholder=""
                    ></v-text-field>
                </v-card-text>
                <v-divider class="mt-4"></v-divider>
                <v-card-actions>
                    <v-btn flat @click="cancel">Prekliči spremembe</v-btn>
                    <v-spacer></v-spacer>
                    <v-slide-x-reverse-transition>
                    <v-tooltip
                        v-if="formHasErrors"
                        left
                    >
                        <v-btn
                        slot="activator"
                        icon
                        class="my-0"
                        >
                        <v-icon>refresh</v-icon>
                        </v-btn>
                        <span>Refresh form</span>
                    </v-tooltip>
                    </v-slide-x-reverse-transition>
                    <v-btn color="primary" flat @click="submit">Posodobi</v-btn>
                </v-card-actions>
        </v-card>

        <v-snackbar
        v-model="snackbar"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
        >
        {{ text }}
            <v-btn
                color="pink"
                flat
                @click="snackbar = false"
            >
                Zapri
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import store from '.././store'
export default {
    props: ['id'],

    data: () => ({
        id_blagajne: '',
        naziv_blagajne: '',
        zasedeno: '',
        P_mest: '',
        zasedenost: '',
        cas_osvezitve: '',
        sprememba_zasedenosti: '',
        realna_zasedenost: '',

        zasedeno_prej: '',
        zadnji_popravek: '',
        realna_zasedenost_procenti: '',


        formHasErrors: '',

        snackbar: false,
        y: 'bottom',
        x: 'left',
        mode: '',
        timeout: 6000,
        text: ''

        
    }),

    computed: {
        blagajna() {
            let avt_blagajna = this.$store.getters.avtBlagajne.filter( (blagajna) => blagajna.ID == this.id)

            if(avt_blagajna.length > 0 && avt_blagajna[0].zasedenost_avt_blagajne != null ) {
                this.id_blagajne = avt_blagajna[0].ID
                this.naziv_blagajne = avt_blagajna[0].Avt_blagajna
                this.zasedeno= avt_blagajna[0].Zasedeno,
                this.P_mest= avt_blagajna[0].P_mest,
                this.zasedenost = avt_blagajna[0].Zasedenost,
                this.cas_osvezitve = avt_blagajna[0].Cas_osvezitve

                this.zasedeno_prej = (avt_blagajna[0].zasedenost_avt_blagajne.Zasedeno_prej != null) ? avt_blagajna[0].zasedenost_avt_blagajne.Zasedeno_prej : null
                this.zadnji_popravek = (avt_blagajna[0].zasedenost_avt_blagajne.Zadnji_popravek)
                this.realna_zasedenost = this.realnaZasedenost()
                this.realna_zasedenost_procenti = this.realnaZasedenostProcenti()
            }

            return avt_blagajna
        }
    },

    methods: {
        submit() {
            //console.log("ID blagajne: " + this.id_blagajne);
            //console.log("Srememba zasedenosti: " + this.sprememba_zasedenosti)

            if(this.sprememba_zasedenosti.trim() != '' && this.sprememba_zasedenosti != null) {
                this.$store.dispatch('AVT_BLAGAJNA_UPDATE', {
                    id_blagajne: this.id_blagajne,
                    zasedenost: this.zasedeno,
                    sprememba_zasedenosti: this.sprememba_zasedenosti

                })
                .then(response => {
                    this.cas_spremembe = response.data.data;
                    this.text = 'Posodabljanje zasedenosti blagajne ' + this.naziv_blagajne + ' je uspelo.'

                    if(this.text.length > 68) {
                        this.mode = 'multi-line'
                    }
                    else {
                        this.mode = 'single-line'
                    }

                    this.snackbar = true
                    this.$store.dispatch('AVT_BLAGAJNE')
                })
                .catch(error => {
                    console.log(error)
                })
            }
        },
        

        cancel() {
            let avt_blagajna = this.$store.getters.avtBlagajne.filter( (blagajna) => blagajna.ID == this.id)

            if(avt_blagajna.length > 0) {
                this.id_blagajne = avt_blagajna[0].ID
                this.naziv_blagajne = avt_blagajna[0].Avt_blagajna
                this.zasedeno = avt_blagajna[0].Zasedeno,
                this.cas_osvezitve = avt_blagajna[0].Cas_osvezitve
                this.sprememba_zasedenosti = ""
            }
        },

        realnaZasedenost() {
            return (parseInt(this.zasedeno) - parseInt(this.zasedeno_prej) +  parseInt(this.zadnji_popravek))
        },

        realnaZasedenostProcenti() {
            return (this.P_mest != null && this.P_mest > 0 && this.P_mest != '') ? ((this.realnaZasedenost() / this.P_mest)*100).toFixed(1) : null
        }
    },

    created() {

    },

    mounted() {
        //console.log(this.id)
        //console.log(this.blagajna)
    }
}
</script>

<style scoped>

</style>


